export const getPartnerBranchName = (partner, language = "en") => {
  const branch = partner?.branchId ?? partner?.branch
  if (!branch) return null
  if (typeof branch === "object") {
    return language === "sa" ? branch.nameAr || branch.name : branch.name
  }
  return null
}

export const getPartnerProfilePhoto = partner =>
  partner?.profilePhoto || partner?.photo || null
